
import { action } from "satcheljs";
import { IPreviewSchedulePageStore } from "../store/PreviewSchedulePageStore";
import { Moment } from "moment";
import { ScheduleCalendarType } from "../../../../sh-models";

export const updatePreviewScheduleViewDimensions = action(
    'UPDATE_PREVIEW_SCHEDULE_VIEW_DIMENSIONS',
    (
        viewState: IPreviewSchedulePageStore,
        selectedDate: Moment | null,
        scheduleCalendarType: ScheduleCalendarType | null
    ) =>
    ({
        viewState: viewState,
        selectedDate: selectedDate,
        scheduleCalendarType: scheduleCalendarType
    })
);

export default updatePreviewScheduleViewDimensions;